<template lang="pug">
  div.loyalty-cards
      ods-module.loyalty-cards__box
        div(slot="header").loyalty-cards__content
          div.loyalty-cards__icon
            i.ods-icon-chart-line
          span.loyalty-cards__title {{ title }}
        div.loyalty-cards__body
          p.loyalty-cards__body-text {{ body }}
        div(style="position: relative")
          router-link.loyalty-cards__button(:to="{name: namePath }")
            ods-button(type="text" icon="ods-icon-arrow-right")
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      required: true
    },
    data: {
      type: Object
    },
    namePath: {
      type: String,
      required: true
    }
  },
  name: 'LoyaltyCard',
  data: () => {
    return {
      path: ''
    }
  }
}
</script>
<style lang="scss">
.loyalty-cards{
  padding: rem(0) rem(64) rem(64) rem(0);

  &__box{
    width: rem(326);
    height: rem(232);
    border: rem(1) solid #2E6C99;
    box-sizing: border-box;
    border-radius: rem(2);
  }
  &__content{
    display: flex;
    flex-direction: row;
  }
  &__icon{
    margin-right: rem(8);
    background-color: #E3EBF1;
    height: rem(32);
    width: rem(32);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__title{
   display: flex;
   align-items: center;
   justify-content: center;
  }
  &__button{
    position: absolute;
    right: rem(-42);
    top: rem(6);
    padding: 0;
  }
  &__body{
   max-height: 85%;
  }
  &__body-text{
   line-height: rem(22);
  }
.ods-module__body{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 40%;
  padding: rem(0) rem(32) !important;
  padding-top: 0 !important;
}
.ods-module__header{
  padding-left: rem(32) !important;
  padding-top: rem(32) !important;
  padding-bottom: rem(24) !important;
}
}
</style>
